module.exports = __webpack_public_path__ + "media/lizardman.cf48d3ab.mp3";